<ng-container *notInPopulation="[populations.Pts, populations.Suite]">
  <div class="full-page-container">
    <fgb-banner [title]="'rewards.page.title' | translate"></fgb-banner>
    <div class="d-block d-lg-none">
      <fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/'"></fgb-page-header>
    </div>

    <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

    <div class="container mb-4">
      <div class="rules-banner d-flex align-items-center">
        <div class="left-rules-banner d-flex align-items-center">
          <img src="assets/images/mytwins-primary-logo.png" alt="" />
          <h3 class="rules-content text-white text-uppercase m-0">{{ 'sweepstakes.content' | translate }}</h3>
        </div>
        <a
          href="https://www.mlb.com/twins/fans/mytwins-membership-rewards-sweepstakes"
          target="_blank"
          class="rules-button bg-tertiary text-white"
          >{{ 'sweepstakes.button' | translate }}</a
        >
      </div>
    </div>

    <div class="container mt-4">
      <fgbcl-lottos-list [isList]="true" [defaultSort]="0"></fgbcl-lottos-list>
    </div>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.Pts, populations.Suite]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
